"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noCheck = void 0;
const parser_1 = require("./parser");
const result_1 = require("./result");
class NoCheckSchema {
    parse(value) {
        return this.debug(value).mapError(parser_1.toMessage);
    }
    debug(data) {
        return (0, result_1.success)(data);
    }
}
/**
 * noCheck accepts a Type and will return a parser
 * that always succeeds to parse.
 *
 * It is not validating anything.
 *
 * It's useful when you are migrating big types
 * and one of the type does not have a parser yet.
 *
 * @example
 * import { t, Infer } from "typegate";
 *
 * const schema = t.noCheck<number>();
 * type Schema = Infer<typeof schema>;
 * //     🔎 number
 *
 * schema.parse(123);            // ✅ Success
 * schema.parse(null);           // ✅ Success
 * schema.parse(["abc", "def"]); // ✅ Success
 *
 * // ----------------------------------------------
 *
 * type Person = { name: string, age: number};
 * const personSchema = t.noCheck<Person>();
 * type InferredPerson = Infer<typeof personSchema>;
 * //       🔎 Person
 *
 * personSchema.parse(123);            // ✅ Success
 * personSchema.parse(null);           // ✅ Success
 * personSchema.parse(["abc", "def"]); // ✅ Success
 * personSchema.parse(["abc", "def"]); // ✅ Success
 * @see {@link https://typegate.dev Need help? Official Guide}
 */
const noCheck = () => new NoCheckSchema();
exports.noCheck = noCheck;
